// Pure helpers for GlobalSearchModal (kept apart so they can be unit-tested).
// See openspec/changes/global-search-rework/specs/global-search/spec.md.

/**
 * The single place a search result type maps to a URL.
 *  - story / output: the project's Outputs dock, that output open as a
 *    read-only markdown tab (ChatSessionPage's ?openOutput=).
 *  - chat: that session, message highlighted.
 *  - file: the editor.  asset / entity: the project's asset library.
 *  - project (and anything unknown): the project's chat.
 */
export const routeFor = (r) => {
  switch (r.type) {
    case 'file': return `/editor/${r.fileId}`;
    case 'chat': return `/projects/${r.projectId}/chat/${r.sessionId}?highlightMessageId=${encodeURIComponent(r.messageId)}`;
    case 'story':
    case 'output': return `/projects/${r.projectId}/chat?openOutput=${encodeURIComponent(r.outputId)}`;
    case 'asset':
    case 'entity': return `/projects/${r.projectId}/assets`;
    default: return `/projects/${r.projectId}/chat`;
  }
};

/** Same tokenization the server uses: lowercase terms of 2+ chars, deduped. */
export const queryTerms = (q) => [...new Set(
  String(q || '').toLowerCase().split(/[\s,;]+/).map((t) => t.trim()).filter((t) => t.length >= 2)
)].slice(0, 6);

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Split text into [{ text, match }] so matched terms can be highlighted. */
export const splitByTerms = (text, terms) => {
  const str = String(text || '');
  if (!str || !terms.length) return [{ text: str, match: false }];
  const re = new RegExp(`(${terms.map(escapeRegExp).join('|')})`, 'gi');
  return str.split(re).filter((p) => p !== '').map((p, i) => ({ text: p, match: i % 2 === 1 }));
};
